/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Total_SkusInputs */

const vi_report_inventory_total_skus = /** @type {(inputs: Report_Inventory_Total_SkusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng SKU`)
};

/**

* @param {Report_Inventory_Total_SkusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_total_skus = /** @type {((inputs?: Report_Inventory_Total_SkusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Total_SkusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_total_skus(inputs)
});